import Button from '../../../../../ui/Button/BlockButton';
import { useTheme } from '../../../../../../hooks/useTheme';
import { useGlobalSettings } from '../../../../../../hooks/useGlobalSettings';
import { SponsoredPill } from './SponsoredPill';
import styles from '../Disco.module.css';

interface CoverTeaserProps {
  offerCount: number;
  retailerMoniker: string;
  onClaimOffers: () => void;
}

export function CoverTeaser({
  offerCount,
  retailerMoniker,
  onClaimOffers,
}: CoverTeaserProps) {
  const theme = useTheme();
  const { retailerName } = useGlobalSettings();

  return (
    <div style={{ fontFamily: theme.bodytextDefaultNone?.fontFamily }}>
      <SponsoredPill />
      <h2
        className={styles.coverTeaserHeading}
        style={{
          fontFamily: theme.headersMediumNone?.fontFamily,
          color: theme.headersMediumNone?.color,
        }}
      >
        You have {offerCount} offers waiting
      </h2>
      <p
        className={styles.coverTeaserSubheading}
        style={theme.bodytextDefaultNone}
      >
        Matched to your recent order from {retailerName || retailerMoniker}
      </p>
      <Button onClick={onClaimOffers} big>
        VIEW {offerCount} OFFERS
      </Button>
    </div>
  );
}
